import $ from 'jquery'
import browserdetect from '../../common/js/browserdetect/browserdetect'

var self = window.RevealIt = {
  elems: null,
  init: function () {
    self.elems = $('.reveal-it')
    self.initTransition()
  },
  reInit: function () {
    self.init()
  },
  initTransition: function () {
    self.elems.addClass('reveal-it-loaded')
    $(document).ready(function () {
      var reqFrame = (window.requestAnimationFrame ? window.requestAnimationFrame : window.setTimeout)
      reqFrame(function () { // required if elements do not have the correct size yet on page load
        self.onScrollTransition()
        $(window).unbind('scroll', self.onScrollTransition)
        $(window).bind('scroll', self.onScrollTransition)
      })
    })
  },
  isSmallerThanQuarterWindow: function (windowHeight, elem) {
    return elem.height() < windowHeight * 0.25
  },
  isEndOfPage: function (windowHeight, elem, percent) {
    var documentHeight = $(document).height()
    return elem.offset().top >= documentHeight - windowHeight * percent
  },
  onScrollTransition: function () {
    var scrollTop = $(window).scrollTop()
    var windowHeight = $(window).height()
    if ($('html').hasClass('iPad')) {
      windowHeight = window.innerHeight ? window.innerHeight : $(window).height()
      windowHeight += 20
    }
    self.elems.each(function () {
      var elem = $(this)
      if (scrollTop + (windowHeight * 0.75) >= elem.offset().top) {
        if (!elem.hasClass('view')) {
          elem.addClass('view')
          // elem.trigger('revealit') - jQuery's .trigger() might not work with bundler if several instances are loaded, use Vanilla JS dispatchEvent() instead!
          elem[0].dispatchEvent(self.createEvent('revealit'))
        }
      } else if (self.isSmallerThanQuarterWindow(windowHeight, elem) && self.isEndOfPage(windowHeight, elem, 0.25)) {
        if (scrollTop + (windowHeight - elem.height()) >= elem.offset().top) {
          if (!elem.hasClass('view')) {
            elem.addClass('view')
            // elem.trigger('revealit') - jQuery's .trigger() might not work with bundler if several instances are loaded, use Vanilla JS dispatchEvent() instead!
            elem[0].dispatchEvent(self.createEvent('revealit'))
          }
        } else {
          elem.removeClass('view')
        }
      } else {
        elem.removeClass('view')
      }
    })
  },
  createEvent: function (eventName) {
    if (browserdetect.isIE) {
      var event = document.createEvent('Event')
      event.initEvent(eventName, true, true)

      return event
    } else {
      return new Event(eventName)
    }
  }
}

$(document).ready(function () {
  self.init()
})



// WEBPACK FOOTER //
// ./src/components/basepage/_reveal-it.js